'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  events: {
    allEvents: 'Tous les événements',
    addEvent: 'Ajouter un événement',
    audiencebox: {
      name: 'Publics cibles'
    },
    authorFilter: {
      createdBy: 'créés par',
      all: 'n’importe qui',
      me: 'moi',
      other: 'd’autres que moi'
    },
    calendarBox: {
      calendars: 'Calendriers'
    },
    categoriesBox: {
      choose: 'Catégories'
    },
    createdBy: 'Créé par %{author}',
    createEvent: 'Créer un événement',
    dateCount: 'Une date |||| %{smart_count} dates',
    dateFilter: {
      future: 'Événements à venir',
      past: 'Événements passés',
      all: 'Tous les événements'
    },
    empty: 'Aucun événement.',
    facebookBox: {
      add: 'Entrez l’adresse de l’événement Facebook existant :',
      name: 'Événement Facebook'
    },
    form: {
      calendar: {
        applyToAllDates: 'Appliquer aux autres dates',
        backToDates: 'Ajouter d’autres dates',
        cancel: 'Annuler',
        chooseMode: 'L’événement a lieu',
        dateTime: 'Date et heure',
        modeMultiple: 'à des dates précises',
        modeRange: 'à chaque jour',
        modeSingle: 'à une seule date',
        otherDates: 'Une autre date |||| %{smart_count} autres dates',
        save: 'OK',
        selectDate: 'Sélectionnez une date pour choisir l’heure.',
        selectHours: 'Choisir l’heure',
        selectedDate: '%{smart_count} date sélectionnée |||| %{smart_count} dates sélectionnées',
        time: {
          add: 'Ajouter une plage horaire',
          endTime: 'Heure indéterminée',
          fillStartTime: 'Remplissez l\'heure de début.',
          from: 'De',
          invalidFormat: 'Format invalide.',
          invalidEndTime: 'Date de fin invalide.',
          startTime: 'Heure de début',
          to: 'à'
        },
        toggleMultipleTimes: 'Cet événement a lieu plusieurs fois en une même journée'
      },
      confirmSave: 'Voulez-vous enregistrer les modifications \xE0 cet \xE9v\xE9nement\xA0?',
      dontSave: 'Ne pas enregistrer',
      importedFrom: 'Importé de',
      save: 'Enregistrer',
      status: {
        title: 'Statut :',
        draft: 'Brouillon',
        pending: "En attente d'approbation",
        published: 'Publié'
      },
      required: 'requis'
    },
    groupsBox: {
      add: 'Ajoutez des groupes :',
      groupAlreadyExists: 'Le groupe existe déjà',
      help: 'Tapez quelques lettres pour commencer à chercher',
      noResults: 'Aucun résultat.',
      title: 'Groupes',
      typeSome: 'Tapez pour lancer la recherche...'
    },
    integrationJsBox: {
      hide: 'Cacher',
      markupLabel: 'Balises HTML',
      replacements: 'Remplacements disponibles : {foreach $events}{/foreach}', // TODO
      show: 'Afficher',
      styleLabel: 'Feuille de style (CSS)',
      title: 'Intégration Javascript'
    },
    loading: 'Chargement...',
    next: 'Page suivante',
    noResults: 'Aucun résultat.',
    previous: 'Page précédente',
    priceBox: {
      addPrice: 'Ajouter un prix',
      donation: 'Contribution volontaire',
      fixed: 'Payant',
      free: 'Gratuit',
      specifyProtocol: 'Toujours spécifier http:// ou https:// .',
      title: 'Prix',
      ticketingWebsite: 'Site web de la billeterie'
    },
    sortDirection: {
      asc: 'en ordre croissant',
      desc: 'en ordre décroissant'
    },
    sortOrder: {
      created_at: 'date de création',
      start_date: 'date de l’événement',
      title: "titre de l'événement",
      updated_at: 'date de mise à jour'
    },
    status: {
      declined: 'Refusé',
      deleted: 'Supprimé',
      draft: 'Brouillon',
      partially_published: 'Partiellement publié',
      pending: 'En attente d’approbation',
      published: 'Publié'
    },
    statusFilter: {
      all: 'publiés et non-publiés',
      published: 'publiés',
      partiallyPublished: 'partiellement publiés',
      pending: "en attente d'approbation",
      declined: 'refusés',
      draft: 'brouillons',
      deleted: 'supprimés'
    },
    tagBox: {
      add: 'Ajoutez des mots-clés :',
      createTag: 'Créer le mots-clé',
      help: 'Exemples : cinéma, astrobiologie, post-rock',
      title: 'Mots-clés',
      select: 'Sélectionner...',
      tagAlreadyExists: 'Le mot-clé existe déjà.',
      typeSome: 'Tapez pour lancer la recherche...'
    },
    termsBox: {
      add: 'Ajoutez des %{key} :',
      help: 'Tapez quelques lettres pour commencer à chercher'
    },
    title: 'Événements',
    titleBox: {
      help: 'Titre de l’événement'
    },
    to: 'au',
    total: '%{smart_count} événement classé par |||| %{smart_count} événements classés par',
    typeBox: {
      choose: 'Choisissez le type d’événement :',
      help: 'Exemples: Conférence, Atelier, Exposition',
      name: 'Type d’événement',
      noResults: 'Aucun résultat.'
    },
    updatedAt: 'Modifié le %{date}',
    venueBox: {
      venueByDates: 'Lieux différents selon la date',
      otherVenuesByDates: 'Autres lieux par date...',
      applyToEmptyDates: 'Appliquer aux dates sans lieu',
      address: 'Adresse',
      backToSearch: 'Retour à la recherche',
      chooseRegion: 'Sélectionner une région',
      city: 'Ville',
      createVenue: 'Créer le lieu',
      createRoom: 'Créer la salle',
      name: 'Nom',
      noResults: 'Aucun résultat.',
      optional: '(facultatif)',
      phone: 'Téléphone',
      postalCode: 'Code postal',
      region: 'Région',
      room: 'Salle',
      rooms: 'Salles',
      saveVenue: 'OK',
      searchOrAddVenue: 'Recherchez ou ajoutez un lieu…',
      specifyProtocol: 'Toujours spécifier http:// ou https:// .',
      typeSome: 'Tapez pour lancer la recherche...',
      website: 'Site web'

    },
    videoBox: {
      enterAddress: 'Entrez l’adresse d’une vidéo YouTube ou Vimeo:',
      video: 'Vidéo'
    }
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/locales/fr/events.js
// module id = 2293
// module chunks = 0